export const courses = [
  {
    "id": "tarot-great-work-practitioner",
    "slug": {
      "en": "tarot-great-work-practitioner",
      "es": "tarot-la-gran-obra-practicante",
      "nl": "tarot-het-grote-werk-practitioner",
      "pap": "tarot-e-gran-obra-practitioner"
    },
    "title": {
      "en": "The Adept’s Mirror | Sfdw n Tawrt - Awaken The Healer Within",
      "es": "El Espejo del Adepto | Sfdw n Tawrt - Despierta al Sanador Interior",
      "nl": "De Spiegel van de Adept | Sfdw n Tawrt - Wek de Heler in Jezelf",
      "pap": "E Spil di e Adepto | Sfdw n Tawrt - Spièrta e Kuradó Interno"
    },
    "type": "public-course",
    "level": "practitioner",
    "language": "en",
    "availableLanguages": [
      "en",
      "nl"
    ],
    "description": {
      "en": "This course initiates the Adept into the sacred arts of inner transformation through the lens of Tarot, Neuro-Linguistic Programming (NLP), and Somatic Psychology. It offers a psycho-spiritual journey using archetypes, language, and embodiment as tools for radical self-awareness and healing.",
      "es": "Este curso inicia al Adepto en las artes sagradas de la transformación interior a través del Tarot, la Programación Neurolingüística (PNL) y la Psicología Somática. Ofrece un viaje psico-espiritual que usa los arquetipos, el lenguaje y la corporalidad como herramientas para una autoconciencia y una sanación radicales.",
      "nl": "Deze cursus wijdt de Adept in de heilige kunsten van innerlijke transformatie via Tarot, Neurolinguïstisch Programmeren (NLP) en Somatische Psychologie. Het biedt een psycho-spirituele reis met archetypen, taal en belichaming als hulpmiddelen voor radicaal zelfbewustzijn en heling.",
      "pap": "E kurso aki ta inisiá e Adepto den e artenan sagrado di transformashon interno via Tarot, Programashon Neurolingwístiko (NLP) i Sikologia Somátiko. E ta ofresé un biahe psiko-spiritual ku ta usa arketiponan, idioma i enkarnashon komo hèrmènt pa un outokonsenshi i kurashon radikal."
    },
    "transformationPromise": {
      "en": "Awaken The Healer Within through Tarot, Neuro-Linguistic Programming, and Somatic Psychology.",
      "es": "Despierta al Sanador Interior a través del Tarot, la Programación Neurolingüística y la Psicología Somática.",
      "nl": "Wek de Heler in jezelf via Tarot, Neurolinguïstisch Programmeren en Somatische Psychologie.",
      "pap": "Spièrta e Kuradó Interno via Tarot, Programashon Neurolingwístiko i Sikologia Somátiko."
    },
    "tags": [
      "Psychology",
      "Human Development",
      "Hermetic",
      "Occult Sciences",
      "Esoteric Education",
      "Consciousness Mapping"
    ],
    "objectives": [
      {
        "title": {
          "en": "Understand foundational occult and psychological frameworks",
          "es": "Comprender los marcos ocultos y psicológicos fundamentales",
          "nl": "Fundamentele occulte en psychologische kaders begrijpen",
          "pap": "Komprondé e markonan okulto i sikológiko fundamental"
        }
      },
      {
        "title": {
          "en": "Apply tarot as a mirror of inner states and psychological processes",
          "es": "Aplicar el tarot como espejo de los estados internos y los procesos psicológicos",
          "nl": "Tarot toepassen als spiegel van innerlijke toestanden en psychologische processen",
          "pap": "Apliká tarot komo spil di estadonan interno i prosesonan sikológiko"
        }
      },
      {
        "title": {
          "en": "Develop somatic awareness and emotional regulation",
          "es": "Desarrollar la conciencia somática y la regulación emocional",
          "nl": "Somatisch bewustzijn en emotionele regulatie ontwikkelen",
          "pap": "Desaroyá konsenshi somátiko i regulashon emoshonal"
        }
      },
      {
        "title": {
          "en": "Employ NLP tools for internal alignment and resilience",
          "es": "Emplear herramientas de PNL para la alineación interna y la resiliencia",
          "nl": "NLP-hulpmiddelen inzetten voor innerlijke afstemming en veerkracht",
          "pap": "Usa hèrmèntnan di NLP pa alineashon interno i resiliensia"
        }
      },
      {
        "title": {
          "en": "Map trauma and transmute it into personal power",
          "es": "Mapear el trauma y transmutarlo en poder personal",
          "nl": "Trauma in kaart brengen en omzetten in persoonlijke kracht",
          "pap": "Mapeá trauma i transmutá e den poder personal"
        }
      }
    ],
    "topics": [
      {
        "title": {
          "en": "The Trivium and Divine Thinking",
          "es": "El Trívium y el Pensamiento Divino",
          "nl": "Het Trivium en Goddelijk Denken",
          "pap": "E Trivium i Pensamentu Divino"
        }
      },
      {
        "title": {
          "en": "Embodied Being and Self-Observation",
          "es": "El Ser Encarnado y la Auto-Observación",
          "nl": "Belichaamd Zijn en Zelfobservatie",
          "pap": "Ser Enkarná i Outo-Observashon"
        }
      },
      {
        "title": {
          "en": "Tarot as a Tool for Self-Transformation",
          "es": "El Tarot como Herramienta de Autotransformación",
          "nl": "Tarot als Hulpmiddel voor Zelftransformatie",
          "pap": "Tarot komo Hèrmènt pa Outotransformashon"
        }
      },
      {
        "title": {
          "en": "NLP Foundations and Self-Reprogramming",
          "es": "Fundamentos de la PNL y Autorreprogramación",
          "nl": "NLP-grondslagen en Zelfherprogrammering",
          "pap": "Fundeshi di NLP i Outo-Reprogramashon"
        }
      },
      {
        "title": {
          "en": "Somatic Intelligence and Emotional Alchemy",
          "es": "Inteligencia Somática y Alquimia Emocional",
          "nl": "Somatische Intelligentie en Emotionele Alchemie",
          "pap": "Inteligensia Somátiko i Alkimia Emoshonal"
        }
      },
      {
        "title": {
          "en": "Numerology, Symbols, and Archetypes",
          "es": "Numerología, Símbolos y Arquetipos",
          "nl": "Numerologie, Symbolen en Archetypen",
          "pap": "Numerologia, Símbolonan i Arketiponan"
        }
      },
      {
        "title": {
          "en": "Kabbalistic and Occult Mapping Systems",
          "es": "Sistemas de Mapeo Cabalístico y Oculto",
          "nl": "Kabbalistische en Occulte Kaartsystemen",
          "pap": "Sistemanan di Mapeo Kabalístiko i Okulto"
        }
      }
    ],
    "methodology": [
      {
        "title": {
          "en": "Monographs: 11 foundational + 6 practitioner + 1 manifesto + 22 Major Arcana + 56 Minor Arcana",
          "es": "Monografías: 11 fundamentales + 6 de practicante + 1 manifiesto + 22 Arcanos Mayores + 56 Arcanos Menores",
          "nl": "Monografieën: 11 fundamenteel + 6 practitioner + 1 manifest + 22 Grote Arcana + 56 Kleine Arcana",
          "pap": "Monografíanan: 11 fundamental + 6 praktikante + 1 manifesto + 22 Arkano Mayor + 56 Arkano Menor"
        }
      },
      {
        "title": {
          "en": "Group Sessions: 1x bi-weekly (live or recorded)",
          "es": "Sesiones grupales: 1x quincenal (en vivo o grabadas)",
          "nl": "Groepssessies: 1x tweewekelijks (live of opgenomen)",
          "pap": "Seshonnan di grupo: 1x kada dos siman (na bibo òf grabá)"
        }
      }
    ],
    "materials": [
      {
        "title": {
          "en": "Monographs",
          "es": "Monografías",
          "nl": "Monografieën",
          "pap": "Monografíanan"
        }
      },
      {
        "title": {
          "en": "Tarot Major & Minor Arcana as Psychological study tools",
          "es": "Arcanos Mayores y Menores del Tarot como herramientas de estudio psicológico",
          "nl": "Grote & Kleine Arcana van Tarot als psychologische studiehulpmiddelen",
          "pap": "Arkano Mayor & Menor di Tarot komo hèrmènt di estudio sikológiko"
        }
      },
      {
        "title": {
          "en": "Practices: meditations, body awareness exercises, journaling prompts",
          "es": "Prácticas: meditaciones, ejercicios de conciencia corporal, consignas para diario",
          "nl": "Oefeningen: meditaties, lichaamsbewustzijnsoefeningen, dagboekprompts",
          "pap": "Práktikanan: meditashon, ehersisio di konsenshi di kurpa, prompt pa skirbi diario"
        }
      },
      {
        "title": {
          "en": "Somatic NLP self-guided rituals",
          "es": "Rituales autoguiados de PNL somática",
          "nl": "Zelfgeleide rituelen van somatische NLP",
          "pap": "Ritualnan outoguiá di NLP somátiko"
        }
      }
    ],
    "assessment": [
      {
        "title": {
          "en": "Socratic Dialogue — 40%. Engage in a dialogue with a mentor or fellow adept in which you discuss your understanding of a core principle, such as Truth, Law, Trivium, NLP, Somatic Psychology, or Freedom.",
          "es": "Diálogo Socrático — 40%. Participa en un diálogo con un mentor o un compañero adepto en el que discutas tu comprensión de un principio fundamental, como la Verdad, la Ley, el Trívium, la PNL, la Psicología Somática o la Libertad.",
          "nl": "Socratische Dialoog — 40%. Voer een dialoog met een mentor of mede-adept waarin je je begrip van een kernprincipe bespreekt, zoals Waarheid, Wet, Trivium, NLP, Somatische Psychologie of Vrijheid.",
          "pap": "Diálogo Sokrátiko — 40%. Partisipá den un diálogo ku un mentor òf un kompañero adepto kaminda bo ta papia di bo komprondementu di un prinsipio fundamental, manera Bèrdat, Lei, Trivium, NLP, Sikologia Somátiko òf Libertat."
        }
      },
      {
        "title": {
          "en": "Final Presentation — 60%. Give a short presentation (10-15 minutes) about your journey of transformation: how has it changed your thinking, feelings, and actions?",
          "es": "Presentación Final — 60%. Da una breve presentación (10-15 minutos) sobre tu viaje de transformación: ¿cómo ha cambiado tu manera de pensar, sentir y actuar?",
          "nl": "Eindpresentatie — 60%. Geef een korte presentatie (10-15 minuten) over je transformatiereis: hoe heeft het je denken, voelen en handelen veranderd?",
          "pap": "Presentashon Final — 60%. Duna un presentashon kòrtiku (10-15 minüt) tokante bo biahe di transformashon: kon e a kambia bo manera di pensa, sinti i aktua?"
        }
      }
    ],
    "modules": [
      {
        "title": {
          "en": "The Trivium and Divine Thinking",
          "es": "El Trívium y el Pensamiento Divino",
          "nl": "Het Trivium en Goddelijk Denken",
          "pap": "E Trivium i Pensamentu Divino"
        }
      },
      {
        "title": {
          "en": "Embodied Being and Self-Observation",
          "es": "El Ser Encarnado y la Auto-Observación",
          "nl": "Belichaamd Zijn en Zelfobservatie",
          "pap": "Ser Enkarná i Outo-Observashon"
        }
      },
      {
        "title": {
          "en": "Tarot as a Tool for Self-Transformation",
          "es": "El Tarot como Herramienta de Autotransformación",
          "nl": "Tarot als Hulpmiddel voor Zelftransformatie",
          "pap": "Tarot komo Hèrmènt pa Outotransformashon"
        }
      },
      {
        "title": {
          "en": "NLP Foundations and Self-Reprogramming",
          "es": "Fundamentos de la PNL y Autorreprogramación",
          "nl": "NLP-grondslagen en Zelfherprogrammering",
          "pap": "Fundeshi di NLP i Outo-Reprogramashon"
        }
      },
      {
        "title": {
          "en": "Somatic Intelligence and Emotional Alchemy",
          "es": "Inteligencia Somática y Alquimia Emocional",
          "nl": "Somatische Intelligentie en Emotionele Alchemie",
          "pap": "Inteligensia Somátiko i Alkimia Emoshonal"
        }
      },
      {
        "title": {
          "en": "Numerology, Symbols, and Archetypes",
          "es": "Numerología, Símbolos y Arquetipos",
          "nl": "Numerologie, Symbolen en Archetypen",
          "pap": "Numerologia, Símbolonan i Arketiponan"
        }
      },
      {
        "title": {
          "en": "Kabbalistic and Occult Mapping Systems",
          "es": "Sistemas de Mapeo Cabalístico y Oculto",
          "nl": "Kabbalistische en Occulte Kaartsystemen",
          "pap": "Sistemanan di Mapeo Kabalístiko i Okulto"
        }
      }
    ],
    "assignments": [
      {
        "title": {
          "en": "Socratic Dialogue — 40%",
          "es": "Diálogo Socrático — 40%",
          "nl": "Socratische Dialoog — 40%",
          "pap": "Diálogo Sokrátiko — 40%"
        }
      },
      {
        "title": {
          "en": "Final Presentation — 60%",
          "es": "Presentación Final — 60%",
          "nl": "Eindpresentatie — 60%",
          "pap": "Presentashon Final — 60%"
        }
      }
    ],
    "universityUrl": "/university/",
    "image": "/assets/images/tarot1.png",
    "imageAlt": "Tarot The Great Work practitioner course flyer"
  },
  {
    "id": "tarot-great-work-master-training",
    "slug": {
      "en": "tarot-great-work-master-training",
      "es": "tarot-la-gran-obra-entrenamiento-master",
      "nl": "tarot-het-grote-werk-master-training",
      "pap": "tarot-e-gran-obra-master-training"
    },
    "title": {
      "en": "The Magus’s Path | Sfdw n Tawrt - Hold The Light for Others",
      "es": "El Camino del Mago | Sfdw n Tawrt - Sostén la Luz para Otros",
      "nl": "Het Pad van de Magus | Sfdw n Tawrt - Houd het Licht vast voor Anderen",
      "pap": "E Kaminda di e Magus | Sfdw n Tawrt - Tene e Lus pa Otronan"
    },
    "type": "public-course",
    "level": "master-training",
    "language": "en",
    "availableLanguages": [
      "en",
      "nl"
    ],
    "description": {
      "en": "This advanced course empowers the Initiate to guide others using the Shfdw Tawrt framework. Students learn how to facilitate healing, decode archetypes for others, and build long-term transformational processes. This phase culminates in the embodiment of the Master—healer, teacher, and guardian of sacred gnosis.",
      "es": "Este curso avanzado capacita al Iniciado para guiar a otros mediante el marco Shfdw Tawrt. Los estudiantes aprenden a facilitar la sanación, descifrar arquetipos para otros y construir procesos de transformación a largo plazo. Esta etapa culmina en la encarnación del Maestro: sanador, maestro y guardián de la gnosis sagrada.",
      "nl": "Deze gevorderde cursus stelt de Ingewijde in staat anderen te begeleiden met het Shfdw Tawrt-kader. Studenten leren heling te faciliteren, archetypen voor anderen te ontcijferen en langdurige transformatieprocessen op te bouwen. Deze fase mondt uit in de belichaming van de Meester—heler, leraar en hoeder van heilige gnosis.",
      "pap": "E kurso avansá aki ta kapasitá e Inisiado pa guia otronan ku e struktura Shfdw Tawrt. Studiantenan ta siña fasilitá kurashon, dekodifiká arketiponan pa otronan, i konstruí prosesonan di transformashon di largu plaso. E fase aki ta kulminá den e enkarnashon di e Maestro—kuradó, maestro i wardadó di gnosis sagrado."
    },
    "transformationPromise": {
      "en": "Hold The Light for Others by learning to facilitate healing, decode archetypes, and build long-term transformational processes.",
      "es": "Sostén la Luz para Otros aprendiendo a facilitar la sanación, descifrar arquetipos y construir procesos de transformación a largo plazo.",
      "nl": "Houd het Licht vast voor anderen door te leren heling te faciliteren, archetypen te ontcijferen en langdurige transformatieprocessen op te bouwen.",
      "pap": "Tene e Lus pa Otronan dor di siña fasilitá kurashon, dekodifiká arketiponan i konstruí prosesonan di transformashon di largu plaso."
    },
    "tags": [
      "Psychology",
      "Human Development",
      "Hermetic",
      "Occult Sciences",
      "Mythopoetics",
      "Sacred Literature"
    ],
    "objectives": [
      {
        "title": {
          "en": "Learn to use Tarot, NLP, and somatic techniques to heal others",
          "es": "Aprender a usar el Tarot, la PNL y técnicas somáticas para sanar a otros",
          "nl": "Leren Tarot, NLP en somatische technieken te gebruiken om anderen te helen",
          "pap": "Siña usa Tarot, NLP i teknikanan somátiko pa kura otronan"
        }
      },
      {
        "title": {
          "en": "Develop mastery in coaching and client sessions",
          "es": "Desarrollar maestría en el coaching y las sesiones con clientes",
          "nl": "Meesterschap ontwikkelen in coaching en cliëntsessies",
          "pap": "Desaroyá maestria den coaching i seshonnan ku kliente"
        }
      },
      {
        "title": {
          "en": "Structure transformational journeys for individuals",
          "es": "Estructurar viajes de transformación para individuos",
          "nl": "Transformatiereizen voor individuen structureren",
          "pap": "Strukturá biahenan di transformashon pa individuonan"
        }
      },
      {
        "title": {
          "en": "Master advanced NLP and somatic integration techniques",
          "es": "Dominar técnicas avanzadas de PNL e integración somática",
          "nl": "Geavanceerde NLP- en somatische integratietechnieken beheersen",
          "pap": "Dominá teknikanan avansá di NLP i integrashon somátiko"
        }
      },
      {
        "title": {
          "en": "Embody archetypes and become a vessel of the Logos",
          "es": "Encarnar los arquetipos y convertirse en un vehículo del Logos",
          "nl": "Archetypen belichamen en een vat van de Logos worden",
          "pap": "Enkarná arketiponan i bira un resipiente di e Logos"
        }
      }
    ],
    "topics": [
      {
        "title": {
          "en": "Archetypes in Client Work",
          "es": "Arquetipos en el Trabajo con Clientes",
          "nl": "Archetypen in het Werk met Cliënten",
          "pap": "Arketiponan den Trabou ku Kliente"
        }
      },
      {
        "title": {
          "en": "Somatic Coaching and Healing Language",
          "es": "Coaching Somático y Lenguaje Sanador",
          "nl": "Somatische Coaching en Helende Taal",
          "pap": "Coaching Somátiko i Idioma Kuradó"
        }
      },
      {
        "title": {
          "en": "Advanced NLP for Spiritual and Psychological Reprogramming",
          "es": "PNL Avanzada para la Reprogramación Espiritual y Psicológica",
          "nl": "Geavanceerde NLP voor Spirituele en Psychologische Herprogrammering",
          "pap": "NLP Avansá pa Reprogramashon Spiritual i Sikológiko"
        }
      },
      {
        "title": {
          "en": "Case Studies and Ethical Responsibility",
          "es": "Estudios de Caso y Responsabilidad Ética",
          "nl": "Casestudy's en Ethische Verantwoordelijkheid",
          "pap": "Estudio di Kaso i Responsabilidat Étiko"
        }
      },
      {
        "title": {
          "en": "Soul Journey Mapping and Ritual Process Design",
          "es": "Mapeo del Viaje del Alma y Diseño de Procesos Rituales",
          "nl": "Het in Kaart Brengen van de Zielsreis en Ontwerp van Rituele Processen",
          "pap": "Mapeo di e Biahe di Alma i Diseño di Proseso Ritual"
        }
      }
    ],
    "methodology": [
      {
        "title": {
          "en": "Monographs: 6 Master",
          "es": "Monografías: 6 de Maestría",
          "nl": "Monografieën: 6 Master",
          "pap": "Monografíanan: 6 Master"
        }
      },
      {
        "title": {
          "en": "Group Sessions: 1x bi-week, advanced format",
          "es": "Sesiones grupales: 1x quincenal, formato avanzado",
          "nl": "Groepssessies: 1x tweewekelijks, gevorderd formaat",
          "pap": "Seshonnan di grupo: 1x kada dos siman, formato avansá"
        }
      }
    ],
    "materials": [
      {
        "title": {
          "en": "Monographs",
          "es": "Monografías",
          "nl": "Monografieën",
          "pap": "Monografíanan"
        }
      },
      {
        "title": {
          "en": "Case study worksheets",
          "es": "Hojas de trabajo de estudios de caso",
          "nl": "Werkbladen voor casestudy's",
          "pap": "Formularionan di estudio di kaso"
        }
      },
      {
        "title": {
          "en": "Coaching frameworks",
          "es": "Marcos de coaching",
          "nl": "Coachingkaders",
          "pap": "Markonan di coaching"
        }
      },
      {
        "title": {
          "en": "Custom journey maps & client diagnostic templates",
          "es": "Mapas de viaje personalizados y plantillas de diagnóstico de clientes",
          "nl": "Aangepaste reiskaarten & cliëntdiagnostiek-sjablonen",
          "pap": "Mapanan di biahe personalisá & plantilla di diagnóstiko di kliente"
        }
      },
      {
        "title": {
          "en": "Ritual templates for session opening/closing",
          "es": "Plantillas rituales para la apertura/cierre de sesiones",
          "nl": "Rituele sjablonen voor het openen/sluiten van sessies",
          "pap": "Plantilla ritual pa habri/sera seshon"
        }
      }
    ],
    "assessment": [
      {
        "title": {
          "en": "Written transformational journey for a case (real or archetypal)",
          "es": "Viaje de transformación escrito para un caso (real o arquetípico)",
          "nl": "Geschreven transformatiereis voor een casus (echt of archetypisch)",
          "pap": "Biahe di transformashon skirbí pa un kaso (real òf arketípiko)"
        }
      },
      {
        "title": {
          "en": "Recorded 1-hour mock session with feedback",
          "es": "Sesión simulada de 1 hora grabada con retroalimentación",
          "nl": "Opgenomen mock-sessie van 1 uur met feedback",
          "pap": "Seshon simulá di 1 ora grabá ku feedback"
        }
      },
      {
        "title": {
          "en": "Final initiatic document: The Magus Statement — outlining your sacred service",
          "es": "Documento iniciático final: The Magus Statement — que describe tu servicio sagrado",
          "nl": "Laatste initiatiedocument: The Magus Statement — een beschrijving van je heilige dienst",
          "pap": "Dokumento inisiátiko final: The Magus Statement — ku ta deskribí bo servisio sagrado"
        }
      }
    ],
    "modules": [
      {
        "title": {
          "en": "Archetypes in Client Work",
          "es": "Arquetipos en el Trabajo con Clientes",
          "nl": "Archetypen in het Werk met Cliënten",
          "pap": "Arketiponan den Trabou ku Kliente"
        }
      },
      {
        "title": {
          "en": "Somatic Coaching and Healing Language",
          "es": "Coaching Somático y Lenguaje Sanador",
          "nl": "Somatische Coaching en Helende Taal",
          "pap": "Coaching Somátiko i Idioma Kuradó"
        }
      },
      {
        "title": {
          "en": "Advanced NLP for Spiritual and Psychological Reprogramming",
          "es": "PNL Avanzada para la Reprogramación Espiritual y Psicológica",
          "nl": "Geavanceerde NLP voor Spirituele en Psychologische Herprogrammering",
          "pap": "NLP Avansá pa Reprogramashon Spiritual i Sikológiko"
        }
      },
      {
        "title": {
          "en": "Case Studies and Ethical Responsibility",
          "es": "Estudios de Caso y Responsabilidad Ética",
          "nl": "Casestudy's en Ethische Verantwoordelijkheid",
          "pap": "Estudio di Kaso i Responsabilidat Étiko"
        }
      },
      {
        "title": {
          "en": "Soul Journey Mapping and Ritual Process Design",
          "es": "Mapeo del Viaje del Alma y Diseño de Procesos Rituales",
          "nl": "Het in Kaart Brengen van de Zielsreis en Ontwerp van Rituele Processen",
          "pap": "Mapeo di e Biahe di Alma i Diseño di Proseso Ritual"
        }
      }
    ],
    "assignments": [
      {
        "title": {
          "en": "Written transformational journey for a case",
          "es": "Viaje de transformación escrito para un caso",
          "nl": "Geschreven transformatiereis voor een casus",
          "pap": "Biahe di transformashon skirbí pa un kaso"
        }
      },
      {
        "title": {
          "en": "Recorded 1-hour mock session with feedback",
          "es": "Sesión simulada de 1 hora grabada con retroalimentación",
          "nl": "Opgenomen mock-sessie van 1 uur met feedback",
          "pap": "Seshon simulá di 1 ora grabá ku feedback"
        }
      },
      {
        "title": {
          "en": "The Magus Statement",
          "es": "The Magus Statement",
          "nl": "The Magus Statement",
          "pap": "The Magus Statement"
        }
      }
    ],
    "universityUrl": "/university/",
    "image": "/assets/images/tarot2.png",
    "imageAlt": "Tarot The Great Work master training course flyer"
  }
];
